module.exports = __webpack_public_path__ + "img/mission3.21092640.png";